export default __webpack_public_path__ + "static/media/flopilates.4b98500d.png";